import { Field, Float, ID, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import type { ShippingWeightUnitEnum } from './ShippingWeightUnitEnum'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('ShippingWeightInput')
export class ShippingWeight {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('swgt') })
  _id: string

  @Field(() => Float)
  @Prop({ type: Number })
  value: number

  @Field(() => String)
  @Prop({ type: String })
  unit: ShippingWeightUnitEnum
}
